<template>
  <el-dialog
    title="协议配置"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="565px"
    v-dialogDrag
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="150px"
      size="small"
    >
      <el-form-item label="接入协议" prop="protocolTypeName">
        <el-input
          v-model="detailRow.protocolTypeName"
          placeholder="请输入"
          class="w-280px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="设备厂商" prop="manufacturerName">
        <el-input
          v-model="detailRow.manufacturerName"
          placeholder="请输入"
          class="w-280px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item :label="item.name" :prop="item.value" v-for="(item, index) in tableData" :key="index">
        <el-input
          v-model="ruleForm[item.value]"
          placeholder="请输入"
          class="w-280px"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm" :loading="saveLoading">保存</el-button>
      <el-button @click="dialogShow = false">取消</el-button>
    </div>

  </el-dialog>
</template>

<script>
import { IOTDeviceTemplateApi, IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const ioTdeviceManagementApi = new IOTDeviceTemplateApi()
const iOTDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
export default {
  name: 'protocolConfig',
  props: {
    show: Boolean,
    type: {
      type: String,
      default: 'edit',
    },
    detailRow: Object,
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      tableData: [],
      saveLoading: false,
      jsonContent: {}
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  methods: {
    confirm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          const formData = {}
          Object.keys(this.jsonContent).forEach((key) => {
            formData[key] = this.ruleForm[key]
          })
          const [err] = this.type === 'add' ?
            await iOTDeviceProtocolInstanceApi.create({
              body: {
                protocolCode: this.detailRow.protocolTypeCode,
                name: this.ruleForm.name,
                jsonContent: JSON.stringify(formData),
              // tid: this.detailRow.tid
              }
            }) :
            await iOTDeviceProtocolInstanceApi.update(this.detailRow.id, {
              body: {
                protocolCode: this.detailRow.protocolTypeCode,
                name: this.ruleForm.name,
                jsonContent: JSON.stringify(formData),
                // tid: this.detailRow.tid,
                id: this.detailRow.id
              }
            })
          if (!err) {
            this.$emit('reload')
            this.$message.success(this.type === 'add' ? '新增成功' : '编辑成功')
            this.dialogShow = false
          }
          this.saveLoading = false
        }
      })
    },
    // 获取协议配置模板
    async getProtocolConfig() {
      const [err, res] = await ioTdeviceManagementApi.getIOTDeviceTemplateProtocolSystem({
        // manufacturerCode: this.detailRow.manufacturer,
        protocolTypeCode: this.detailRow.protocolTypeCode,
      })
      if (!err) {
        this.jsonContent = JSON.parse(res)
        const tableData = [{
          name: '实例名称',
          value: 'name'
        }]
        const rules = {}
        Object.keys(this.jsonContent).forEach((key) => {
          tableData.push({
            name: key,
            value: key
          })
          rules[key] = [{ required: true, message: '请输入', trigger: 'blur' }]
          this.tableData = tableData
          this.rules = {
            ...{
              name: [{ required: true, message: '请输入', trigger: 'blur' }],
            },
            ...rules
          }
        })
        this.ruleForm = { ...this.ruleForm, ...{ name: '' }, ...res }
      }
    }
  },
  created() {
    if (this.type === 'add') {
      this.getProtocolConfig()
    } else {
      this.jsonContent = JSON.parse(this.detailRow.jsonContent)
      const tableData = [{
        name: '实例名称',
        value: 'name'
      }]
      const rules = {}
      Object.keys(this.jsonContent).forEach((key) => {
        tableData.push({
          name: key,
          value: key
        })
        rules[key] = [{ required: true, message: '请输入', trigger: 'blur' }]
        this.tableData = tableData
        this.rules = {
          ...{
            name: [{ required: true, message: '请输入', trigger: 'blur' }],
          },
          ...rules
        }
      })
      this.ruleForm = {
        name: this.detailRow.name,
        ...this.jsonContent
      }
    }
  }
}
</script>
